import { render, staticRenderFns } from "./MasterTable.vue?vue&type=template&id=c0593b0c&scoped=true&"
import script from "./MasterTable.vue?vue&type=script&lang=js&"
export * from "./MasterTable.vue?vue&type=script&lang=js&"
import style0 from "./MasterTable.vue?vue&type=style&index=0&id=c0593b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0593b0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VRow})
